const ENReportsCrud = {
	"Novo relatório":"New report",
	"Relatório excluído com sucesso":"Report successfully deleted",
	"Erro ao excluir relatório":"Error on deleting report",
	"Exclusão de relatório":"Delete report",
	"Deseja realmente excluir o relatório":"Do you really want to delete the report",
	"Digite o nome do relatório para excluí-lo":"Enter the name of the indicator to delete it",
	"Titulo do relatório não confere":"Report title doesn't match",
	"O código sql é obrigatório":"Sql field is required",
	"O campo Url é obrigatório":"Url field is required",
	"O conteúdo HTML é obrigatório":"HTML content is required",
	"Label é requerido":"Label is required",
	"Lista de opções é obrigatória":"Option list is required",
	"Ao menos uma opção deve ser informado":"At least one option must be informed",
	"Valores das opções não podem ser repetidas":"Option values ​​cannot be repeated",
	"Operador é requerido":"Operator is required",
	"Valor final é requerido":"Final value is required",
	"Relatório adicionado com sucesso":"Report successfully added",
	"Relatório alterado com sucesso":"Report successfully changed",
	"Erro ao adicionar relatório":"Error on adding report",
	"Erro ao alterar relatório":"Error on changing report",
	"Adicionar relatório":"Add report",
	"Duplicar relatório":"Duplicate report",
	"Alterar relatório":"Change report",
	"Erro ao encontrar relatório":"Error on finding report",
	"Erro ao exportar relatório": "Error exporting report",
	"Ações associadas":"Associated actions",
	"Esperava um \"SELECT\" e encontrou \"{{value}}\"":"Expected a \"SELECT\" and found \"{{value}}\"",
	"Reprocesso de colunas":"Column reprocessing",
	"A consulta foi alterada e novas colunas foram encontradas":"The query was changed and new columns were found",
	"Deseja reprocessar as colunas existentes":"Do you want to reprocess existing columns",
	"Erro ao identificar comando sql":"Error on identifying SQL command",
	"Erro ao reprocesar colunas":"Error on reprocessing columns",
	"Titulo abreviado":"Abbreviated title",
	"Mostrar titulo":"Show title",
	"Uso interno":"Intern use",
	"Utiliza paginação":"Use pagination",
	"Registros p/ página":"Records per page",
	"Tempo de atualização":"Update time",
	"Valor mínimo (eixo Y)":"Minimum value (Y axis)",
	"Formatar coluna":"Format column",
	"Remover coluna":"Remove column",
	"Relatório exportado com sucesso": "Report exported successfully",
	"Valor padrão":"Default value",
	"Valor livre":"Open value",
	"Lista de opções":"List of options",
	"Lista de valores":"List of values",
	"Obrigatório":"Required",
	"Excluir opção":"Delete option",
	"Adicionar opção":"Add option",
	"Adicionar regra":"Add rule",
	"Operador da formatação":"Formatting operator",
	"Coluna de referência":"Reference column",
	"Excluir regra":"Delete rule",
	"Tamanho da fonte":"Font size",
	"Cor da fonte":"Font color",
	"Formatação avançada":"Advanced formatting",
	"Visualizar opções":"View options",
	"Binds reservadas":"Private binds",
	"As variáveis \"EFA001_ID\", \"EFA002_ID\", \"EFA005_ID\", são variáveis reservadas do sistema":"The binds \"EFA001_ID\", \"EFA002_ID\", \"EFA005_ID\", are system private binds"
};

export default ENReportsCrud;
